import { InputProps } from '@mui/material';
import { lazy, Suspense } from 'react';
import { NumericFormatProps } from 'react-number-format';
import { useLocale } from '../../../context/NbLocalizationContext';

const NumericFormat = lazy(() => import('./numericFormatBase'));

export function NbNumericFormat<BaseType = InputProps>(props: NumericFormatProps<BaseType>) {
  const { translation } = useLocale();
  return (
    <Suspense fallback={null}>
      <NumericFormat
        decimalSeparator={translation.numericFormat.decimalSeparator}
        thousandSeparator={translation.numericFormat.thousandSeparator}
        decimalScale={2}
        allowNegative={false}
        {...props}
      />
    </Suspense>
  );
}
